import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { Button } from '@mui/material';
import { useNavigate } from "react-router-dom";
import useSystemDesigns from '../../api/useOpportunitySDS';
import './CustomModal.css';
import { toast } from 'react-toastify';

interface QuoteRow {
  Id: string;
  OpportunityId: string;
  Opportunity: {
    Name: string;
    Project_ID__c: string;
  };
  calculator__c: string | null;
  is_manual__c: boolean;
  system_design__c: string | null;
}

function CloneModal({
  row,
  onHide,
  ...props
}: {
  row: QuoteRow;
  onHide: () => void;
}) {
  const navigate = useNavigate();
  const { data: systemDesigns, isLoading, error } = useSystemDesigns(row?.OpportunityId);
  const [selectedSystemDesign, setSelectedSystemDesign] = useState<string | undefined>(
    row?.system_design__c ?? undefined
  );

  if (error) {
    toast.warning('Failed to retrieve system designs, please retry', {
      position: toast.POSITION.TOP_RIGHT
    });
  }

  const handleClone = () => {
    if (selectedSystemDesign === undefined) {
      toast.warning("Please select a system design", {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    let url = '/calculator?id=' + row.Id +
      '&opportunityId=' + row.OpportunityId +
      '&businessName=' + encodeURIComponent(row.Opportunity.Name) +
      '&projectId=' + row.Opportunity.Project_ID__c +
      '&action=clone';

    if (selectedSystemDesign && selectedSystemDesign !== 'none') {
      url += '&systemDesign=' + selectedSystemDesign;
    }

    navigate(url);
  };

  const handleSelectedSystemDesign = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (systemDesigns && systemDesigns.length) {
      const selected = systemDesigns.filter(x => x.id === e.target.value);
      if (selected && selected.length) {
        setSelectedSystemDesign(selected[0].id);
      } else {
        setSelectedSystemDesign(undefined);
      }
    }
  };

  function renderOptions() {
    if (systemDesigns && systemDesigns.length) {
      const result = [<option key="none" value="none">None</option>];
      for (let i = 0; i < systemDesigns.length; i++) {
        result.push(
          <option key={systemDesigns[i].id} value={systemDesigns[i].id}>
            {systemDesigns[i].name}
          </option>
        );
      }
      return result;
    }
    return <option>None</option>;
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" />
      </Modal.Header>
      <h2 className='modal-heading'>
        Cloning SQ for {row?.Opportunity?.Project_ID__c} {row?.Opportunity?.Name}
      </h2>
      <Modal.Body className='modal-custom-body'>
        <h4 className='modal-subheading'>System Design</h4>
        <Form.Select style={{ width: '380px' }} value={selectedSystemDesign ?? 'none'} onChange={handleSelectedSystemDesign}>
          {isLoading ? <option>Loading...</option> : renderOptions()}
        </Form.Select>
        {!selectedSystemDesign && (
          <Form.Text style={{ color: '#FF7E0B' }}>
            {isLoading ? "Loading..." : "Please select a system design to clone the sales quote"}
          </Form.Text>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outlined" onClick={onHide}>Cancel</Button>
        <Button
          disabled={isLoading || !selectedSystemDesign}
          variant="contained"
          style={{ color: 'white', marginLeft: '10px' }}
          onClick={handleClone}>
          Clone Sales Quote
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CloneModal;
